// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"ModalWrapper_modal-wrapper__AWw7d"};